export default[
    {
        title: 'Mes commissions',
        icon: 'DollarSignIcon',
        route: 'commissions-list',
        tagVariant: 'light-danger',
        typeUser: 'courtier',
    },
]
